// src/components/TranslationIntro.js
import React, { useEffect } from 'react';

const TranslationIntro = () => {
  useEffect(() => {
    // Re-trigger scrollAnimations() from your script.js
    if (window.$ && typeof window.$.fn.scrollAnimations === 'function') {
      const $containers = window.$('[data-animation]:not([data-animation-text]), [data-animation-box]');
      $containers.scrollAnimations();
    }
  }, []);

  return (
    <section className="about-style-four pt_150 pb_150">
      <div className="auto-container">
        <div className="row align-items-center">
          {/* Left Image Column */}
          <div className="col-lg-6 col-md-12 col-sm-12 content-column">
            <div className="image_block_one">
              <div className="image-box pl_50 pt_50 pb_50 mr_40" data-animation-box>
                <div
                  className="image-shape"
                  style={{ backgroundImage: 'url(/assets/images/shape/shape-3.png)' }}
                ></div>
                <div className="row clearfix">
                  <div className="col-lg-12 col-md-6 col-sm-12 single-column">
                    <figure
                      className="image image-1 overlay-anim-black-bg"
                      data-animation-text
                      data-animation="overlay-animation"
                    >
                      <img
                        src="/assets/images/resource/faq-1.jpg"
                        alt="Translation"
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Text Column */}
          <div className="col-lg-6 col-md-12 col-sm-12 content-column">
            <div className="content_block_six">
              <div className="content-box ml_40">
                <div data-animation-box className="sec-title mb_30">
                  <span
                    data-animation-text
                    className="sub-title overlay-anim-white-bg"
                    data-animation="overlay-animation"
                  >
                    Translation Services
                  </span>
                  <h2>Expert in Native Languages</h2>
                </div>
                <div className="inner-box mb_40">
                  <div className="single-item mb_30">
                    <p>
                      Wications is a trusted translation agency specializing in regional Indian and
                      Sri Lankan languages. From government documents to business content and
                      digital media, we deliver precise, culturally adapted translations to help you
                      engage local and global audiences effectively.
                    </p>
                  </div>
                  <div className="text-box mb_40">
                    <ul className="list-style-one clearfix">
                      <li>Tamil, Telugu, Kannada, Malayalam</li>
                      <li>Sinhala & Tamil (Sri Lanka)</li>
                      <li>Legal, Medical, Technical Expertise</li>
                      <li>Multilingual Marketing & Digital Content</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TranslationIntro;